module.exports = __webpack_public_path__ + "static/media/threestepiconactive3.ed8c2d9e.png";